import { request } from '@/config/request/interceptors'
import { ShopEmailSettingRespDTO } from '@/service/customer'
import store from '@/store'
import { useRequest } from '@/util/useLoading'
import { computed, onMounted, ref } from 'vue'

const customerShopId = computed(() => store.getters.curShop || store.getters.shopInfo?.customerShopId)
const useEmailSetting = () => {
  const emailSetting = ref<ShopEmailSettingRespDTO>()
  onMounted(async () => {
    if (customerShopId.value) {
      const result = await request.customer.aws.shopEmailSettingDetail({ customerShopId: customerShopId.value })
      emailSetting.value = result.data
    }
  })
  return [emailSetting]
}

export {
  useEmailSetting
}
